import { Box, styled } from '@mui/material'
import { Detective, Eye } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary'

type TaskVisibilityIconProps = { isLimitedVisibility: boolean; size?: 'small' | 'medium' }

export function TaskVisibilityIcon({ isLimitedVisibility, size = 'medium' }: TaskVisibilityIconProps) {
    const iconSize = size === 'small' ? tokens.SizingIconS : tokens.SizingIconM
    const weight = size === 'small' ? 'bold' : 'regular'
    return (
        <TaskIconWrapper $isWarning={isLimitedVisibility} $size={size}>
            {isLimitedVisibility ? (
                <Detective size={iconSize} color={tokens.ColorIconWarning} weight={weight} />
            ) : (
                <Eye size={iconSize} color={tokens.ColorIconInformative} weight={weight} />
            )}
        </TaskIconWrapper>
    )
}

const TaskIconWrapper = styled(Box, {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})(({ $isWarning, $size }: { $isWarning: boolean; $size: 'small' | 'medium' }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: $isWarning ? tokens.ColorSurfaceWarningDefault : tokens.ColorSurfaceInformativeDefault,
    boxSizing: 'border-box',
    ...TASK_VISIBILITY_VARIANTS[$size],
}))

export default TaskVisibilityIcon

const TASK_VISIBILITY_VARIANTS = {
    small: {
        height: '24px',
        width: '24px',
        borderRadius: '4px',
        padding: '4px',
    },
    medium: {
        height: '36px',
        width: '36px',
        borderRadius: '6px',
        padding: '6px',
    },
}
